export const GET_RESTAURANT_MENU = 'GET_RESTAURANT_MENU'
export const UPDATE_RESTAURANT_MENU = 'UPDATE_RESTAURANT_MENU'
export const UPDATE_RESTAURANT_MENU_LAST_UPDATED =
  'UPDATE_RESTAURANT_MENU_LAST_UPDATED'
export const GET_CONFIRMATION_RESTAURANT_MENU =
  'GET_CONFIRMATION_RESTAURANT_MENU'
export const UPDATE_CONFIRMATION_RESTAURANT_MENU =
  'UPDATE_CONFIRMATION_RESTAURANT_MENU'
